module.exports = __webpack_public_path__ + "img/hk.fc3ab38e.jpg";